import { Grid } from '@mui/material';
import React from 'react';
import { RenderInputByTypeMobile } from '../../../components/formGroupGenerator/RenderInputByTypeMobile';
import { CustomButton } from '../../../components/customButton/CustomButton';
import moment from 'moment';

export const PrecioControlFilters = ({
    delegaciones = [],
    estados = [],
    filters,
    handleChangeFilters,
    handleSearch,
    estadoPendienteId
}) => {

    const onChangeIdEstado = (_, value) => {
        if (value === filters.idEstado) return;

        if (filters.idEstado === estadoPendienteId) {
            const today = moment();

            handleChangeFilters('fechaHasta', today.format('yyyy-MM-DD'));
            handleChangeFilters('fechaDesde', today.add(-15, 'days').format('yyyy-MM-DD'));
        }

        if (value === estadoPendienteId) {
            handleChangeFilters('fechaDesde', null);
            handleChangeFilters('fechaHasta', null);
        }

        handleChangeFilters('idEstado', value);
    }

    return (
        <>
            <Grid
                container
                spacing={2}
                sx={{ marginBottom: '25px' }}
            >
                <Grid size='grow'>
                    <RenderInputByTypeMobile
                        input={{
                            type: 'select',
                            displayName: 'Delegacion',
                            name: 'idDelegacion',
                            options: delegaciones
                        }}
                        value={filters.idDelegacion}
                        handleChange={handleChangeFilters}
                    />
                </Grid>
                <Grid size='grow'>
                    <RenderInputByTypeMobile
                        input={{
                            type: 'select',
                            displayName: 'Estado',
                            name: 'idEstado',
                            options: estados
                        }}
                        value={filters.idEstado}
                        handleChange={onChangeIdEstado}
                    />
                </Grid>
                {estadoPendienteId !== filters.idEstado && <>
                    <Grid size='grow'>
                        <RenderInputByTypeMobile
                            input={{
                                type: 'date',
                                displayName: 'Fecha Desde',
                                name: 'fechaDesde',
                                disableFuture: true
                            }}
                            value={filters.fechaDesde}
                            handleChange={handleChangeFilters}
                        />
                    </Grid>
                    <Grid size='grow'>
                        <RenderInputByTypeMobile
                            input={{
                                type: 'date',
                                displayName: 'Fecha Hasta',
                                name: 'fechaHasta',
                                disableFuture: true
                            }}
                            value={filters.fechaHasta}
                            handleChange={handleChangeFilters}
                        />
                    </Grid>
                </>}
                <Grid size='grow' sx={{ mt: '3px' }}>
                    <CustomButton
                        label='Buscar'
                        variant='contained'
                        color='primary'
                        size='small'
                        onClick={handleSearch}>
                    </CustomButton>
                </Grid>
            </Grid>
        </>
    )
}